import axios from "axios";

export class AmountOperationService {
    getAmountOperationInstitution() {
        return axios.get('/appapv/getAmountOperationInstitution.action', {}).then(res => res.data.payload);
    }


    getAmountOperationAdministrator(institutionId) {
        return axios.get('/appapv/getAmountOperationAdministrator.action', {
            params: {
                idInstitucion: institutionId,
            }
        }).then(res => res.data.payload);
    }

    setAmountOperation(borrowerId, isOperation, amountOperation) {
        return axios.post('/appapv/setAmountOperation.action', {}, {
            params: {
                idInstitucionPTT: borrowerId,
                opera: isOperation,
                lineaCredito: amountOperation,
            }
        }).then(res => res.data);
    }
}